import { StyledIconButton } from "@components/button";
import { StyledText } from "@components/text/Text.styles";
import styled from "styled-components";

export const CalendarFieldWrapper = styled.div`
    display: flex;
    margin-right: 60px;
    align-self: flex-start;
`;

export const WorkDayIntervalsFastEntryWrapper = styled.div`
    align-self: flex-start;
    min-width: 340px;

    ${StyledText} {
        min-width: 50px;
    }
`;

export const WorkDayIntervalsFastEntryHeader = styled.div`
    display: flex;
    align-items: center;
    margin-bottom: 15px;

    ${StyledIconButton} {
        margin-left: 15px;
    }
`;

export const WeekContentAfter = styled.div`
    padding: 28px 13px 7px;

    & > div:nth-of-type(2) {
        margin-top: 27px;
    }
`;

export const WorkingPatternText = styled.p`
    line-height: 1.6;
    margin: 0;
`;